"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CTA_BUTTON = void 0;
const CTA_BUTTON = exports.CTA_BUTTON = 'cta-button';
